<template>
  <div>
    <div v-if="loading">
      <vue-element-loading :active="true" :is-full-screen="true" />
    </div>
    <CCard v-if="!loading" style="margin-top: 20px">
      <!-- <CCardHeader>
        <h5>
          <b>{{ this.gameName }}</b>
        </h5>
      </CCardHeader> -->
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose Field Type</h5> </CCol>
                      <CCol sm="5">
                        <input
                          @change="fieldChange"
                          type="radio"
                          style="width: 57px; height: 21px"
                          v-model="fieldtype"
                          value="RoomIDandPassword"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID and Password
                        </span>
                      </CCol>
                      <CCol sm="4">
                        <input
                          @change="fieldChange"
                          type="radio"
                          v-model="fieldtype"
                          value="RoomID"
                          style="width: 57px; height: 21px"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID</span
                        >
                      </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <label>Room ID</label>
                <CInput v-model="roomID" />
              </CCol>

              <CCol sm="6" v-if="fieldtype == 'RoomIDandPassword'">
                <label>Room Password</label>
                <CInput v-model="roomPassword" />
              </CCol>
              <CCol sm="12" style="text-align: center !important">
                <br /><br />
                <CButton color="success" style="width: 20%" @click="saveGame()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
    
    <script>
import firebase from "firebase";
const db = firebase.firestore();
import VueElementLoading from "vue-element-loading";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { Vselect } from "@/components";
export default {
  components: { VueCtkDateTimePicker, Vselect, VueElementLoading },
  data() {
    return {
      roomPassword: "",
      roomID: "",
      id: "",
      fieldtype: "",
      loading: false,
    };
  },
  watch: {
    platformFee() {
      if (this.platformFee >= 100) {
        this.showMessage("Platform Fee Should be Less Than 100", "warning");
      } else {
        this.displayFee = 100 - this.platformFee;
      }
    },
  },
  methods: {
    fieldChange() {
      console.log(this.fieldtype);
    },

    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },

    async saveGame() {
      // console.log("isRoomEnabled", this.isRoomEnabled);
      //   this.subtractMinutes(15, this.MatchStarttime);

      if (this.roomID == "") {
        this.showMessage("Room Id is Required", "warning");
      } else if (
        this.fieldtype == "RoomIDandPassword" &&
        this.roomPassword == ""
      ) {
        this.showMessage("Room Password is Required", "warning");
      } else {
        this.loading = true;

        // this.isActive = true;

        // subract 15 mins in extrapay time for room time
        let data = {
          id: this.id,
          isRoomId: this.fieldtype == "RoomID" ? true : false,
          roomId: this.roomID,
          roomPassword: this.roomPassword,
        };
        console.log("data", data);
        try {
          let resp = await axios.post(
            "https://scramble-api.rage.fan/esportsRoomIdUpdate",
            // "http://localhost:5000/token-geomine/us-central1/api/saveTournament",
            // "http://localhost:5000/token-geomine/us-central1/api/saveTournament",
            { ...data }
          );
          this.loading = false;
          console.log("resp", resp);
          console.log("data", data);
          if (resp.data.status == true) {
            this.showMessage("Data Updated Successfully", "success");
            this.$router.push({ name: "esportsList" });
          } else {
            this.showMessage("Couldn't save Esports tournament", "error");

            //   this.$router.push({ name: "tournaments" });
          }
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      }
    },
  },
  created() {
    console.log(" this.$route.params", this.$route.params);
    this.id = this.$route.params.id;
    this.roomID = this.$route.params.roomId;
    this.roomPassword = this.$route.params.roomPassword;
    this.fieldtype = this.$route.params.isRoomId
      ? "RoomID"
      : "RoomIDandPassword";

    console.log("entered created", this.id, this.roomID, this.roomPassword);
  },
};
</script>
    